// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1iAbH","containerItemsCenter":"Skeleton_containerItemsCenter__2oSy0"};